import React from 'react';
import SkeletonContent from 'react-native-skeleton-content';
import {t} from 'react-native-tailwindcss';

interface Props {
  isLoading: boolean;
  numberOfEntries: number;
}

export const LoadingEntriesSkeleton: React.FC<Props> = ({isLoading, numberOfEntries, children}) => {
  return (
    <SkeletonContent
      isLoading={isLoading}
      containerStyle={[t.flex1, t.flexGrow]}
      layout={[...Array(numberOfEntries)].map((_, i) => ({
        key: i,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginHorizontal: 20,
        marginTop: 8,
        marginBottom: 25,
        children: [
          {
            width: 32,
            height: 32,
            borderRadius: 18,
            marginRight: 20,
            marginTop: 8
          },
          {
            height: 51,
            flex: 1
          }
        ]
      }))}>
      {children}
    </SkeletonContent>
  );
};
